module.exports = __webpack_public_path__ + "img/delivery-icon.bf1201e4.png";